import { useEffect, useState } from "react";
import { T, TF } from "react-translator-component";
import { Box, IconButton, Typography } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import CommentsModal from "./commentModal/CommentsModal";

interface Props {
  post: any;
  highlightWords: string[];
  commentStatuses: string[];
}

export default function PostCommentButton({ post, highlightWords, commentStatuses }: Props) {
  const [showCommentsModal, setShowCommentsModal] = useState<boolean>(false);
  const [commentCount, setCommentCount] = useState<number>(0);

  useEffect(() => {
    if (!post) return
    setCommentCount(post.comments_count)
  }, [post]);

  const handleChangeComments = (count: number) => {
    setCommentCount(count)
  }

  return (
    <>
      <Box>
        <IconButton
          onClick={() => setShowCommentsModal(true)}
          aria-label="thumbs"
        >
          <CommentIcon />
          <Typography>{TF(T("mng_post_comment_count"), commentCount ?? 0)}</Typography>
        </IconButton>
      </Box>

      <CommentsModal
        open={showCommentsModal}
        post={post}
        highlightWords={highlightWords}
        closeModal={() => setShowCommentsModal(false)}
        onChange={(count: number) => handleChangeComments(count)}
        commentStatuses={commentStatuses}
      />
    </>
  );
}